import React, { type ReactNode } from "react"
import { Navigate } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { useCommunicationRights } from "../../communication-permissions.ts"

/** Templates moved into Communication; someone who can only reach the old Settings page keeps it. */
export const EmailTemplatesMovedRedirect = ({
  fallback
}: {
  fallback: ReactNode
}) => {
  const rights = useCommunicationRights()
  return rights.templates ? (
    <Navigate to={RoutesPaths.communication.settingsTemplates} replace />
  ) : (
    <>{fallback}</>
  )
}
